(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const pad = (n) => String(n).padStart(2, '0');

  /* Countdown (topbar) : 10 minutes par visiteur, relance a 10:00 une fois termine */
  $$('[data-rk-cd]').forEach((el) => {
    const h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el);
    const dur = Number(el.dataset.minutes || 10) * 60 * 1000;
    const key = 'rk-cd-end';
    const read = () => { try { return Number(localStorage.getItem(key)) || 0; } catch (e) { return 0; } };
    const write = (v) => { try { localStorage.setItem(key, String(v)); } catch (e) {} };
    let end = read();
    if (!end || end <= Date.now() || end - Date.now() > dur) { end = Date.now() + dur; write(end); }
    const tick = () => {
      let left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { end = Date.now() + dur; write(end); left = Math.floor(dur / 1000); }
      h.textContent = pad(Math.floor(left / 3600));
      m.textContent = pad(Math.floor((left % 3600) / 60));
      s.textContent = pad(left % 60);
    };
    tick(); setInterval(tick, 1000);
  });

  /* Header shadow */
  const hdr = $('.rk-header');
  if (hdr) addEventListener('scroll', () => hdr.classList.toggle('is-stuck', scrollY > 10), { passive: true });

  /* Dialogs (menu) */
  $$('[data-rk-open]').forEach((b) => b.addEventListener('click', () => { const d = document.getElementById(b.dataset.rkOpen); d && d.showModal && d.showModal(); }));
  $$('dialog.rk-navdrawer').forEach((d) => { d.addEventListener('click', (e) => { if (e.target === d || e.target.closest('[data-rk-close]')) d.close(); }); });

  /* Gallery */
  $$('[data-rk-gal]').forEach((g) => {
    const track = $('[data-rk-track]', g);
    const slides = $$('.rk-gal__slide', track);
    const thumbs = $$('[data-rk-thumb]', g);
    const dots = $$('.rk-dots i', g);
    const idx = () => Math.round(track.scrollLeft / track.clientWidth);
    const go = (i) => { i = (i + slides.length) % slides.length; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); };
    const sync = () => { const i = idx(); thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i)); dots.forEach((d, k) => d.classList.toggle('is-on', k === i)); const t = thumbs[i]; if (t) t.parentElement.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' }); };
    $('[data-rk-prev]', g)?.addEventListener('click', () => go(idx() - 1));
    $('[data-rk-next]', g)?.addEventListener('click', () => go(idx() + 1));
    thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
    let tm; track.addEventListener('scroll', () => { clearTimeout(tm); tm = setTimeout(sync, 60); }, { passive: true });
    g.rkGo = go; sync();
  });

  /* Variant picker */
  const form = $('[data-rk-form]');
  const vjson = $('[data-rk-variants]');
  if (form && vjson) {
    const variants = JSON.parse(vjson.textContent);
    const money = (c) => (window.rkMoney || '{{amount_with_comma_separator}} €').replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toFixed(2).replace('.', ','));
    const update = () => {
      const opts = $$('[data-rk-opt]', form).reduce((a, fs) => { const c = $('input:checked', fs); if (c) a[Number(fs.dataset.rkOpt)] = c.value; return a; }, []);
      $$('[data-rk-optname]').forEach((el) => { const i = Number(el.dataset.rkOptname); if (opts[i]) el.textContent = opts[i]; });
      const v = variants.find((x) => x.options.every((o, i) => !opts[i] || o === opts[i]));
      if (!v) return;
      $$('input[name=id]', form).forEach((i) => (i.value = v.id));
      const p = $('[data-rk-price]'), c = $('[data-rk-compare]'), b = $('[data-rk-off]');
      if (p) p.textContent = money(v.price);
      if (c) { c.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      if (b && v.compare_at_price > v.price) b.textContent = Math.round((1 - v.price / v.compare_at_price) * 100) + '% OFF';
      const st = $('.rk-sticky__t small'); if (st) st.textContent = money(v.price);
      const add = $('[data-rk-add]'); if (add) add.disabled = !v.available;
      /* sync Rapid Bundle selects (best effort) */
      $$('.rapi-bundles__bar-variant-select select, select[class*=rapi_option]').forEach((sel) => {
        const want = opts.find((o) => o && [...sel.options].some((op) => op.value === o || op.text === o));
        const op = want && [...sel.options].find((x) => x.value === want || x.text === want);
        if (op && sel.value !== op.value) { sel.value = op.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      if (v.media_index != null) { const g = $('[data-rk-gal]'); g && g.rkGo && g.rkGo(v.media_index); }
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    };
    form.addEventListener('change', (e) => { if (e.target.closest('[data-rk-opt]')) update(); });
  }

  /* Viewers */
  $$('[data-rk-viewers]').forEach((el) => {
    const min = Number(el.dataset.min || 9), max = Number(el.dataset.max || 24);
    let n = min + Math.floor(Math.random() * (max - min + 1));
    const b = $('b', el); b.textContent = n;
    setInterval(() => { n = Math.min(max, Math.max(min, n + (Math.random() > .5 ? 1 : -1))); b.textContent = n; }, 6000);
  });

  /* Carousels */
  $$('[data-rk-car]').forEach((c) => {
    const track = $('.rk-carousel__track', c);
    const items = [...track.children];
    const dots = $$('[data-rk-dots] i', c);
    const idx = () => Math.round(track.scrollLeft / track.clientWidth);
    const go = (i) => { i = (i + items.length) % items.length; track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: 'smooth' }); };
    const sync = () => dots.forEach((d, k) => d.classList.toggle('is-on', k === idx()));
    $('[data-rk-cprev]', c)?.addEventListener('click', () => go(idx() - 1));
    $('[data-rk-cnext]', c)?.addEventListener('click', () => go(idx() + 1));
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    const auto = Number(c.dataset.auto || 0);
    if (auto && items.length > 1) { let hover = false; c.addEventListener('mouseenter', () => (hover = true)); c.addEventListener('mouseleave', () => (hover = false)); setInterval(() => { if (!hover) go(idx() + 1); }, auto * 1000); }
    sync();
  });

  /* Sticky ATC */
  const sticky = $('[data-rk-sticky]'), buy = $('[data-rk-add]');
  if (sticky && buy) {
    new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(buy);
    $('[data-rk-sticky-add]', sticky).addEventListener('click', () => { buy.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(() => buy.click(), 350); });
  }
})();
